import { VyuTheme } from './types'
import defaultMessages from '../messages/en.json'
import DetectImg from '../assets/images/enno-detect.gif'
import DecideGenuineImg from '../assets/images/enno-decide-genuine.gif'
import DecideNonGenuineImg from '../assets/images/enno-decide-not-genuine.gif'
import GenuineLogo from '../assets/images/enno-genuine-logo.gif'
import CannotConfirmLogo from '../assets/images/enno-cannot-confirm-logo.png'
import FakeLogo from '../assets/images/enno-fake-logo.png'
import QualityIssueLogo from '../assets/images/enno-quality-issue-logo.png'
import Background from '../assets/images/enno-background.png'

export const createTheme = (): VyuTheme => {
  return {
    name: 'Default theme',
    colors: {
      primary: '#4e008f',
      secondary: 'transparent',
      heading: '#1d1d1f',
      description: '#515163',
      btnText: '#ffffff',
      v1: {
        primary: '#343739',
        secondary: 'transparent',
        heading: '',
        description: '',
        btnText: '#ffffff',
      },
    },
    messages: defaultMessages,
    fonts: {
      primary: {
        family: 'Carnas',
        type: 'default',
        src: '',
      },
    },
    images: {
      detect: DetectImg,
      decide: {
        genuine: DecideGenuineImg,
        nonGenuine: DecideNonGenuineImg,
      },
      overlay: {
        genuine: { url: GenuineLogo },
        photoQualityIssue: { url: QualityIssueLogo },
        potentialFake: { url: FakeLogo },
        cannotConfirm: { url: CannotConfirmLogo },
      },
      background: Background,
    },
  }
}
